import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { GlobalNav2, useGlobalNavQueryParam2 } from '@greatmindsorg/assess-web-core-lib';
import { useRipl } from '@greatmindsorg/ripl-react';
import { user } from '@greatmindsorg/ripl-core';
import { StyledNavigationContainer } from './Header.styled';
export const Header = () => {
  useGlobalNavQueryParam2();
  const router = useRouter();
  const userRipl = useRipl()?.getUser();
  if (!userRipl) return null;
  const getTabIndex = useMemo(() => {
    return (pathname: string) => {
      if (pathname) {
        if (pathname.startsWith('/reports')) return 1;
        if (pathname.startsWith('/resources') || pathname.startsWith('/library')) return 2;
        return 0;
      }
      return 0;
    };
  }, []);
  const tabIndex = getTabIndex(router.pathname);
  return <>
      <StyledNavigationContainer>
        <GlobalNav2 mainContentId="#main" user={userRipl as user.User} protectedRoutes={['/home', '/library', '/reports']} tabSelected={tabIndex} />
      </StyledNavigationContainer>
    </>;
};